import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { Observable, finalize } from 'rxjs';

import { PendingRequestsService } from '../service/pending-requests.service';

const SILENT_PATHS: readonly string[] = [
  '/api/auth/heartbeat',
  '/api/auth/me',
];

function isSilent(url: string): boolean {
  return SILENT_PATHS.some((path: string): boolean => url.includes(path));
}

export const PendingRequestsInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (isSilent(request.url)) {
    return next(request);
  }

  const pendingRequests = inject(PendingRequestsService);

  pendingRequests.start();

  return next(request).pipe(finalize((): void => pendingRequests.stop()));
};
